import { getEndPoint, TNodeEntry } from '@udecode/plate';
import { Range } from 'slate';
import { BufferEditor } from '../BufferEditor/types.plate';

export const isSelectionAtEndOfCurrentNode = (
  editor: BufferEditor,
  nodeEntry: TNodeEntry
): boolean => {
  if (!editor.selection) return false;

  const [, path] = nodeEntry;
  const end = getEndPoint(editor, path);
  return Range.equals(editor.selection, {
    anchor: end,
    focus: end,
  });
};
